import React from 'react';

const StudyText = (props) => {
  return(
    <div>
      <h4><b>{props.study}</b></h4>
      <p>{props.center}</p>
      <p>{props.from} - {props.to}</p>
      <p></p>
    </div>
  )
}

export default StudyText;